<div class="relative w-full" [style.height.px]="height">
    <!-- Canvas -->
    <canvas #signatureCanvas
        class="w-full h-full border border-gray-300 rounded-lg cursor-crosshair touch-none"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()"
        (mouseleave)="onMouseUp()"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd($event)">
    </canvas>

    <!-- Placeholder (visible quand vide) -->
    <div *ngIf="isEmpty"
        class="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span class="text-gray-300 text-4xl italic select-none">{{ placeholder }}</span>
    </div>
</div>

<!-- Label + Effacer -->
<div class="flex justify-between items-center mt-1 px-1">
    <span class="text-sm text-gray-500">{{ placeholder }}</span>
    <button type="button"
        (click)="clear()"
        class="text-sm text-blue-600 hover:text-blue-800 cursor-pointer">
        [Effacer]
    </button>
</div>